import React, { useState } from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { DateField } from '@mui/x-date-pickers/DateField';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Button from '@mui/material/Button';




export default function PatientAnagraphic() {
  const [occupazione, setOccupazione] = useState('');
  const [lingua_parlata, setLinguaParlata] = useState('');
  const [showCaregiver, setShowCaregiver] = useState(false);
  const [caregivers, setCaregivers] = useState([
    { nome: '', telefono: '', parentela: '' }
  ]);


  return (
    
<Box
  component="form"
  sx={{ 
    m: 1,
    width: '50ch',
    display: 'grid',
    rowGap: 2,
    columnGap: 3,
    gridTemplateColumns: 'repeat(3, 1fr)'
  }}
  noValidate
  autoComplete="off"
  
> 
  <Box
    sx={{
    gridColumn: 'span 3',
    p: 3,
    mb: 2,
    border: '1px solid rgba(0,0,0,0.23)',
    borderRadius: 2,
    backgroundColor: '#f5f5f5',
    textAlign: 'center'
    }}
  >

    <Box
    component="h1"
    sx={{
      m: 0,
      fontSize: '1.8rem',
      fontWeight: 'bold',
      color: '#1976d2' // colore blu MUI
    }}
    >
      Cartella Infermieristica Digitale
    </Box>


    <Box
      component="p"
      sx={{
        m: 0,
        mt: 1,
        fontSize: '1rem',
        color: 'text.secondary'
      }}
      >
      Inserisci i dati anagrafici del paziente e informazioni correlate
    </Box>
  </Box>

    
    
  <TextField id="nome" label="Nome" variant="outlined" required />
  <TextField id="cognome" label="Cognome" variant="outlined" required />


  <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker label="Data di nascita" />
  </LocalizationProvider>

  <TextField id="luogo_nascita" label="Luogo Nascita" variant="outlined"  />
  <TextField id="cittadinanza" label="Cittadinanza" variant="outlined"  />
  <TextField id="residenza" label="Residenza/Domicilio" variant="outlined"  />
  <TextField id="via" label="Via" variant="outlined"  />
  <TextField id="telefono" label="Recapito Telefonico" variant="outlined"  />
  <TextField id="cellulare" label="Cellulare" variant="outlined"  />


  {/* Sesso RadioButton */}
  <FormControl 
  sx={{
    px:2,
    border:'solid 1px #0000003B',
    
  }}>
    <FormLabel id="stato-civile-label">
      Sesso
    </FormLabel>
    <RadioGroup
    row
    aria-labelledby="demo-radio-buttons-group-label"
    defaultValue="Maschio"
    name="radio-buttons-group"
    required
    >
      <FormControlLabel value="Maschio" control={<Radio />} label="Maschio" />
      <FormControlLabel value="Femmina" control={<Radio />} label="Femmina" />
    </RadioGroup>
  </FormControl>

  {/* Stato Civile RadioButton */}
  <FormControl 
  sx={{
    px:3,
    border:'1px solid #0000003B',
    gridColumn: 'span 2'
  }}>

    <FormLabel id="stato-civile-label">
      Stato Civile
    </FormLabel>

    <RadioGroup
    sx={{
      display: 'grid',
      gridTemplateColumns: 'repeat(3, auto)',
      columnGap: 2,
      rowGap: 1,
    }}
    aria-labelledby="stato-civile-label"
    defaultValue="coniugato"
    name="radio-buttons-group"
    required
    >
      <FormControlLabel value="coniugato" control={<Radio />} label="Coniugato/a" />
      <FormControlLabel value="vedovo" control={<Radio />} label="Vedovo/a" />
      <FormControlLabel value="celibe" control={<Radio />} label="Celibe" />
      <FormControlLabel value="nubile" control={<Radio />} label="Nubile" />
      <FormControlLabel value="altro" control={<Radio />} label="Altro" />
    </RadioGroup>
  </FormControl>

  {/* Modalità di vita RadioButton */}
  <FormControl 
  sx={{
    px:3,
    border:'1px solid #0000003B',
    // gridColumn: 'span 2' 
  }}>
    <FormLabel id="stato-civile-label">
      Modalità di vita
    </FormLabel>

    <RadioGroup
    sx={{
      display: 'grid',
      gridTemplateColumns: 'repeat(2, auto)',
      columnGap: 2,
      rowGap: 1,
    }}
    aria-labelledby="stato-civile-label"
    defaultValue="coniugato"
    name="radio-buttons-group"
    required>
      <FormControlLabel value="famiglia" control={<Radio />} label="In famiglia" />
      <FormControlLabel value="solo" control={<Radio />} label="Da solo/a" />
      <FormControlLabel value="casa_protetta" control={<Radio />} label="Casa Protetta" />
      <FormControlLabel value="altro" control={<Radio />} label="Altro" />
    </RadioGroup>
  </FormControl>

  {/* Professione RadioButton  */}
  <FormControl 
  sx={{ 
    px: 2,
    border: '1px solid #0000003B' 
  }}>
    <FormLabel>
      Professione
    </FormLabel>

    <RadioGroup
      row
      value={occupazione}
      onChange={(e) => setOccupazione(e.target.value)}
    >
      <FormControlLabel
        value="professione"
        control={<Radio />}
        label="Professione"
      />

      {occupazione === 'professione' && (
        <TextField
          sx={{ ml: 2 }}
          id="professione"
          label="Professione"
          variant="outlined"
          required
        />
      )}

      <FormControlLabel
        value="disoccupato"
        control={<Radio />}
        label="Disoccupato"
      />
    </RadioGroup>
  </FormControl>

  {/* Lingua Parlata */}
  <FormControl sx={{ px: 2, border: '1px solid #0000003B' }}>
    <FormLabel>
      Lingua Parlata
    </FormLabel>

    <RadioGroup
      row
      value={lingua_parlata}
      onChange={(e) => setLinguaParlata(e.target.value)}
    >


      <FormControlLabel
        value="italiano"
        control={<Radio />}
        label="Italiano"
      />

      <FormControlLabel
        value="altro"
        control={<Radio />}
        label="Altro"
      />
      {lingua_parlata === 'altro' && (
        <TextField
          sx={{ ml: 2, mb:2 }}
          id="lingua_parlata"
          label="Indica la lingua"
          variant="outlined"
          required
        />
      )}
    </RadioGroup>
  </FormControl>
    


  {/* Caregiver Section */}
  <Box sx={{ gridColumn: 'span 3' }}>
    <Button
      variant={showCaregiver ? "outlined" : "contained"} 
      color={showCaregiver ? "inherit" : "primary"}    
      sx={{ gridColumn: 'span 3', width: '100%' }}
      onClick={() => {
        setShowCaregiver(!showCaregiver);
        if (!showCaregiver && caregivers.length === 0) {
          setCaregivers([{ nome: '', telefono: '', parentela: '' }]);
        }
      }}
    >
      {showCaregiver ? "Nascondi" : "Aggiungi caregiver"}
    </Button>



    {showCaregiver && (
      <Box
        sx={{
          gridColumn: 'span 3',
          border: '1px solid rgba(0,0,0,0.23)',
          p: 2,
          display: 'grid',
          rowGap: 2
        }}
      >

        {caregivers.map((cg, index) => (
          <Box
            key={index}
            sx={{
              display: 'grid',
              gridTemplateColumns: 'repeat(4, 1fr)', // 3 campi + 1 bottone
              columnGap: 2,
              alignItems: 'center'
            }}
          >
            <TextField
              label="Nome"
              value={cg.nome}
              onChange={(e) => {
                const newCaregivers = [...caregivers];
                newCaregivers[index].nome = e.target.value;
                setCaregivers(newCaregivers);
              }}
            />
            <TextField
              label="Telefono"
              value={cg.telefono}
              onChange={(e) => {
                const newCaregivers = [...caregivers];
                newCaregivers[index].telefono = e.target.value;
                setCaregivers(newCaregivers);
              }}
            />
            <TextField
              label="Parentela"
              value={cg.parentela}
              onChange={(e) => {
                const newCaregivers = [...caregivers];
                newCaregivers[index].parentela = e.target.value;
                setCaregivers(newCaregivers);
              }}
            />
            <Button
              variant="outlined"
              color="error"
              onClick={() => {
                setCaregivers(caregivers.filter((_, i) => i !== index));
              }}
            >
              -
            </Button>
          </Box>
        ))}

        <Button
          startIcon={<span>+</span>}
          onClick={() =>
            setCaregivers([
              ...caregivers,
              { nome: '', telefono: '', parentela: '' }
            ])
          }
          sx={{ mt: 1 }}
        >
          Aggiungi caregiver
        </Button>
      </Box>
    )}



  </Box>

{/* 
  <Table>
  <TableBody>
    <TableRow>
        <TableCell variant="head">Titolo</TableCell>
        <TableCell>Lol</TableCell>
    </TableRow>
    <TableRow>
        <TableCell variant="head">Header 1</TableCell>
        <TableCell>Cell 2</TableCell>
    </TableRow>
  </TableBody>
</Table> */}


</Box>
  );
}